import { Parameter, ParameterValue } from "../../common/types/parameters";
import MultiParameterSelectionCards from "../parameters/multi-parameter-selection-cards";

export default function WizardMultiParameterBlock(params: {
  id: string;
  parameters: Parameter[];
  preSelected?: ParameterValue[];
  onSelection?: (selectedValues: ParameterValue[]) => void;
}) {
  let parametersWithUserInput = params.parameters.map((parameter) => ({
    ...parameter,
    value: params.preSelected?.find(
      (userInput) => userInput.id === parameter.id
    )?.value,
  }));

  return (
    <MultiParameterSelectionCards
      parameters={parametersWithUserInput}
      onValidChange={params.onSelection}
    />
  );
}
